import { smoothScroll } from '../../General/SmoothScroll';

// Fixed header with Headroom
import Headroom from 'headroom.js';
const fixedHeader = document.querySelector('.fixed-header');
if (fixedHeader) {
    const headroom = new Headroom(fixedHeader, {
        offset: 150,
        tolerance: 5
    });
    headroom.init();
}

// Scroll down arrow
const header = document.querySelector('.header');
const btn = document.querySelector('.header__arrow');
if (btn && header) {
    btn.addEventListener('click', () => {
        btn.classList.add('clicked');
        smoothScroll(header.clientHeight - 60, 600);        
        setTimeout(function() {
            btn.classList.remove('clicked');
        }, 1000);
    });
}

